export default "__VITE_ASSET__Cu$vCgx0__"